<template>
  <div class="page-container">
    <Filter :params="params" @search="searchData" add @add="addNew">
      <template #handle>
        <div class="form-col">
          <!-- <el-form-item>
            <el-button type="danger" @click="batchDelete">删除</el-button>
          </el-form-item> -->
          <el-form-item>
            <el-button type="danger" @click="batchStop">{{ $t('activity.list.terminate') }}</el-button>
            <el-button type="primary" plain @click="batchPublish">{{ $t('activity.list.publish') }}</el-button>
          </el-form-item>
        </div>
      </template>
    </Filter>
    <Table ref="tableId" :tableData="tableDataList" :total="total" :size="size" @update="updatePage"
      tooltip-effect="light" single @select="selectHandle">
      <el-table-column type="index" align="center" :label="$t('pages.indexNo')" width="60px" />
      <el-table-column prop="syncTime" :label="$t('activity.list.syncTime')" width="150" />
      <el-table-column prop="name" :label="$t('activity.list.actName')" width="150" />
      <!-- <el-table-column prop="area" :label="$t('activity.list.actRegion')" width="120" /> -->
      <el-table-column prop="area" :label="$t('activity.list.actRegion')" width="120">
        <template #default="{row}">
          {{activityArea.filter(it=> it.value == row.area)?.[0]?.label}}
        </template>
      </el-table-column>
      <el-table-column prop="startDate" :label="$t('activity.list.startDate')" width="120" />
      <el-table-column prop="endDate" :label="$t('activity.list.endDate')" width="120" />
      <!-- <el-table-column label="活动日期" width="200" >
        <template #default="{row}">{{ row.startDate+' 至 '+row.endDate }}</template>
      </el-table-column>
      <el-table-column label="活动时间" width="200" >
        <template #default="{row}">{{ row.startTime+' 至 '+row.endTime }}</template>
      </el-table-column> -->
      <el-table-column prop="type" :label="$t('activity.list.actType')" width="120">
        <template #default="{ row }">{{ row.type }}</template>
      </el-table-column>
      <el-table-column prop="status" :label="$t('activity.list.actStatus')" width="120" />
      <el-table-column prop="publish" :label="$t('activity.list.publishStatus')" width="120">
        <template #default="{ row }">{{
          row.publish ? $t('activity.list.published') : $t('activity.list.unpublished')
        }}</template>
      </el-table-column>
      <el-table-column :label="$t('activity.list.qrCode')" width="120">
        <template #default="{ row }">
          <el-button type="text" size="small" @click="downloadWXAcode(row)">{{$t('activity.list.download')}}</el-button>
        </template>
      </el-table-column>
      <el-table-column :label="$t('activity.list.checkinCount')" width="120">
        <template #default="{ row }">{{ row.signInCount }}/{{ row.signUpCount }}</template>
      </el-table-column>
      <el-table-column prop="owner" :label="$t('activity.list.responsiblePerson')" width="120" />
      <el-table-column prop="isShow" :label="$t('activity.list.frontendDisplay')" width="120">
        <template #default="{ row }">
          {{
            row.isShow
              ? $t('activity.detail.publicVisible') : $t('activity.detail.internalVisible')
          }}
        </template>
      </el-table-column>
      <el-table-column prop="subActivities" :label="$t('activity.list.subAct')" width="120">
        <template #default="{ row }">
          <el-button type="text" size="small" @click="showSubActivities(row)">{{
            row.subActivities?.length || 0
          }}</el-button>
        </template>
      </el-table-column>
      <el-table-column :label="$t('activity.list.operation')" width="210" fixed="right">
        <template #default="{ row }">
          <el-button type="text" size="mini" @click="activityEdit(row, '/activity/detail')">{{ $t('activity.detail.editAct') }}</el-button>
          <el-button v-if="row.status == '已结束'" type="text" size="mini"
            @click="activityEdit(row, '/activity/review')">{{ $t('activity.list.postEdit') }}</el-button>
          <el-button v-if="row.status != '已结束'" type="text" size="mini"
            @click="subActivityEdit(row.id)">{{ $t('activity.list.createSubAct') }}</el-button>
        </template>
      </el-table-column>
    </Table>
    <el-dialog :title="$t('activity.list.createAct')" top="5vh" v-model="dialogFormVisible" destroy-on-close :modal="true"
      :append-to-body="true">
      <el-form ref="detailformRef" class="dialog-form" :model="detailform" :rules="detailformRules" label-width="120px">
        <el-form-item :label="$t('activity.list.actName')" prop="name">
          <el-input v-model="detailform.name" :placeholder="$t('activity.list.actName')" clearable />
        </el-form-item>
        <el-form-item :label="$t('activity.list.actType')" prop="activityTypeCode">
          <el-select v-model="detailform.activityTypeCode" :placeholder="$t('activity.list.actType')" clearable>
            <el-option v-for="item in newTypeList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('activity.list.actDate')" prop="dateRange">
          <el-date-picker v-model="detailform.dateRange" type="daterange" format="YYYY-MM-DD" value-format="YYYY-MM-DD"
            :range-separator="$t('activity.detail.to')" :start-placeholder="$t('activity.list.startDate')"
            :end-placeholder="$t('activity.list.endDate')" clearable />
        </el-form-item>
        <el-form-item :label="$t('activity.list.actTime')" prop="timeRange">
          <el-time-picker v-model="detailform.timeRange" is-range format="HH:mm:ss" value-format="HH:mm:ss"
          :range-separator="$t('activity.detail.to')" :start-placeholder="$t('activity.detail.startTime')"
          :end-placeholder="$t('activity.detail.endTime')" clearable />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" size="small" @click="onFormSubmit">{{ $t('activity.list.confirm') }}</el-button>
      </template>
    </el-dialog>
    <el-dialog :title="subActivity.parent.name" v-model="subActivity.visible" destroy-on-close width="75%" :modal="true"
      :append-to-body="true">
      <!-- <template #title>
        <el-button @click="subActivityEdit(subActivity.parentId)" type="primary" size="mini" plain>添加</el-button>
      </template> -->
      <!-- <el-descriptions title="">
        <el-descriptions-item label="主活动:">{{  }}</el-descriptions-item>
      </el-descriptions> -->
      <el-table class="dialog-table" height="500px" :data="subActivity.data" border stripe>
        <el-table-column prop="name" :label="$t('activity.list.subActName')" width="120" />
        <el-table-column prop="location" :label="$t('activity.list.location')" />
        <el-table-column prop="startDate" :label="$t('activity.list.date')" width="200">
          <template #default="{ row }">
            {{ row.startDate }} - {{ row.endDate }}
          </template>
        </el-table-column>
        <el-table-column prop="startTime" :label="$t('activity.list.time')" width="120">
          <template #default="{ row }">
            {{ row.startTime }} - {{ row.endTime }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('activity.list.qrCode')">
          <template #default="{ row }">
            <el-button type="text" size="small" @click="downloadWXAcode(row)">{{ $t('activity.list.download') }}</el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="status" label="活动状态" width="150" /> -->
        <el-table-column prop="signUpCount" :label="$t('activity.list.signupCount')" width="120" />
        <el-table-column prop="createBy" :label="$t('activity.list.creator')" width="120" />
        <el-table-column prop="createTime" :label="$t('activity.list.createTime')" width="120" />
        <el-table-column :label="$t('activity.list.operation')" width="120px">
          <template #default="{ row }">
            <!-- <el-button @click="deleteApplyform(scope.$index)" type="danger" plain size="mini">删除</el-button> -->
            <el-button type="text" size="mini" @click="subActivityEdit(subActivity.parent.id, row.id)">{{$t('activity.list.edit')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { reactive, toRefs } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'

import Table from '@/components/table/index'
import Filter from '@/components/table/filter'
import useActivity from './useActivity'

import { common } from '@/common/mixin'
import { request, downloadFile } from '@/utils/request'
import { useI18n } from 'vue-i18n'
export default {
  components: {
    Table,
    Filter
  },
  mixins: [common],
  setup() {
    const { t } = useI18n()
    const activityArea = [
      {
        label: t('activity.list.eastChina'),
        value: '华东'
      },
      {
        label:t('activity.list.southChina'),
        value: '华南'
      },
      {
        label: t('activity.list.northChina'),
        value: '华北'
      },
      {
        label: t('activity.list.centralChina'),
        value: '华中'
      },
      {
        label: t('activity.list.southwest'),
        value: '西南'
      },
      {
        label: t('activity.list.northwest'),
        value: '西北'
      },
      {
        label: t('activity.list.northeast'),
        value: '东北'
      }
    ]
    const router = useRouter()
    const { activityTypeList, activityStatusList } = useActivity()
    const newTypeList = [
      {
        label: t('activity.detail.newProduct'),
        value: 6
      },
      {
        label: t('activity.detail.pointsExchange'),
        value: 7
      },
      {
        label: t('activity.detail.digitalMarketing'),
        value: 8
      }
    ]
    const state = reactive({
      params: [
        {
          type: 'Input',
          key: 'name',
          value: '',
          label: t('activity.list.actName')
        },
        {
          type: 'Select',
          key: 'activityTypeCode',
          value: '',
          label: t('activity.list.actType'),
          options: {
            data: activityTypeList,
            label: 'translatedValue',
            value: 'code'
          }
        },
        {
          type: 'Input',
          key: 'owner',
          value: '',
          label: t('activity.list.responsiblePerson')
        },
        {
          type: 'Select',
          key: 'status',
          value: '',
          label: t('activity.list.actStatus'),
          options: {
            data: activityStatusList,
            label: 'translatedValue',
            value: 'code'
          }
        },
        {
          type: 'Select',
          key: 'area',
          value: '',
          label: t('activity.list.actRegion'),
          options: {
            data: activityArea
          }
        },
        {
          type: 'Date',
          key: 'dateRange',
          value: [],
          label: t('activity.list.date'),
          options: {
            type: 'daterange',
            format: 'YYYY-MM-DD',
            'value-format': 'YYYY-MM-DD',
            'range-separator': t('activity.detail.to'),
            'start-placeholder': t('activity.list.startDate'),
            'end-placeholder': t('activity.list.endDate')
          }
        }
      ],
      query: {},
      page: 1,
      size: 10,
      total: 0,
      tableDataList: [],
      batchDataList: [],
      dialogFormVisible: false,
      detailformRef: null,
      detailform: {
        name: '',
        startDate: '',
        endDate: '',
        startTime: '',
        endTime: '',
        dateRange: [],
        timeRange: []
      }
    })
    const subActivity = reactive({
      visible: false,
      parent: {},
      data: []
    })
    const detailformRules = reactive({
      name: {
        required: true,
        message: t('activity.list.enterActName'),
        trigger: 'blur'
      },
      type: {
        required: true,
        message: t('activity.list.selectActType'),
        trigger: 'change'
      },
      dateRange: {
        required: true,
        message: t('activity.list.selectTrainDate'),
        trigger: 'change'
      },
      timeRange: {
        required: true,
        message: t('activity.list.selectTrainTime'),
        trigger: 'change'
      }
    })

    const getData = async () => {
      try {
        const res = await request('getActivityList', {
          ...state.query,
          page: state.page,
          size: state.size
        })
        state.tableDataList = res.records
        state.total = res.total
      } catch (error) {
        console.error(error)
      }
    }
    const searchData = async data => {
      console.log('searchData', data)
      state.query = data
      if (data.dateRange && data.dateRange.length > 0) {
        state.query.startDate = data.dateRange[0]
        state.query.endDate = data.dateRange[1]
      } else {
        state.query.startDate = ''
        state.query.endDate = ''
      }
      getData()
    }
    const updatePage = (page, size) => {
      state.page = page || 1
      state.size = size || 10
      getData()
    }
    // 表格select事件
    const selectHandle = data => {
      console.log(data)
      state.batchDataList = data.map(item => {
        return item.id
      })
    }
    const addNew = () => {
      state.dialogFormVisible = true
      Object.keys(state.detailform).forEach(key => {
        state.detailform[key] = null
      })
    }
    const onFormSubmit = async () => {
      try {
        state.detailformRef && (await state.detailformRef.validate())
        state.detailform.startDate = state.detailform.dateRange[0]
        state.detailform.endDate = state.detailform.dateRange[1]
        state.detailform.startTime = state.detailform.timeRange[0]
        state.detailform.endTime = state.detailform.timeRange[1]
        await request('saveActivity', state.detailform)
        getData()
        state.dialogFormVisible = false
        ElMessage({
          showClose: true,
          type: 'success',
          message: t('activity.list.submitSuccess')
        })
      } catch (error) {
        console.error(error)
      }
    }
    const batchDelete = async () => {
      try {
        if (state.batchDataList.length < 1) {
          ElMessage({
            showClose: true,
            type: 'error',
            message: t('activity.list.selectToDelete')
          })
          return
        }
        await ElMessageBox.confirm(t('activity.list.confirmDelete'), {
          confirmButtonText: t('activity.list.confirm1'),
          cancelButtonText: t('activity.list.cancel'),
          type: 'warning'
        })
        await request('deleteActivity', {
          id: state.batchDataList[0]
        })
        ElMessage({
          showClose: true,
          type: 'success',
          message: t('activity.list.opSuccess')
        })
        getData()
      } catch (error) {
        console.error(error)
      }
    }
    // 中止活动
    const batchStop = async () => {
      try {
        if (state.batchDataList.length < 1) {
          ElMessage({
            showClose: true,
            type: 'error',
            message: t('activity.list.selectToTerminate')
          })
          return
        }
        await request('stopActivity', {
          id: state.batchDataList[0]
        })
        ElMessage({
          showClose: true,
          type: 'success',
          message: t('activity.list.opSuccess')
        })
        getData()
      } catch (error) {
        console.error(error)
      }
    }
    // 发布活动
    const batchPublish = async () => {
      try {
        if (state.batchDataList.length < 1) {
          ElMessage({
            showClose: true,
            type: 'error',
            message: t('activity.list.selectToPublish')
          })
          return
        }
        await request('publishActivity', {
          id: state.batchDataList[0]
        })
        ElMessage({
          showClose: true,
          type: 'success',
          message: t('activity.list.opSuccess')
        })
        getData()
      } catch (error) {
        console.error(error)
      }
    }
    // 二维码下载
    const downloadWXAcode = async row => {
      try {
        const res = await downloadFile('activityAllWXacode', {
          activityId: row.id
        })
        let blob = new Blob([res], { type: 'application/octet-stream' })
        let reader = new FileReader()
        reader.readAsDataURL(blob)
        reader.onload = e => {
          const a = document.createElement('a')
          a.download = row.name + t('activity.list.qrCodeZip')
          a.href = e.target.result
          a.click()
        }
      } catch (error) {
        console.error(error)
      }
    }
    // 活动编辑
    const activityEdit = async (data, url) => {
      console.log(data)
      router.push(`${url}?id=${data.id}&type=${data.activityTypeCode}`)
    }
    // 子活动编辑
    const subActivityEdit = async (parentId = '', id = '') => {
      router.push(`/activity/subActivity?parentId=${parentId}&id=${id}`)
    }
    const showSubActivities = row => {
      subActivity.visible = true
      subActivity.data = row.subActivities
      subActivity.parent = row
    }
    const disabledDate = time => {
      return time.getTime() > Date.now()
    }

    const setupInit = () => {
      try {
        getData()
        // request("syncActivity")
      } catch (error) {
        console.error(error)
      }
    }
    setupInit()
    return {
      newTypeList,
      activityArea,
      ...toRefs(state),
      subActivity,
      detailformRules,
      getData,
      searchData,
      addNew,
      onFormSubmit,
      updatePage,
      downloadWXAcode,
      disabledDate,
      batchStop,
      batchPublish,
      batchDelete,
      selectHandle,
      activityEdit,
      subActivityEdit,
      showSubActivities
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
</style>
